// import * as R from 'ramda'
import React from 'react'
import Bluebird from 'bluebird'
import { connect } from 'react-redux'
import Moment from 'moment'
import ModalErr from './components/modal-error'
import Header from './components/header'
import Footer from './components/footer'
import { Brands, Categories, Menus, Err } from './actions'
import { BrowserRouter, Switch } from 'react-router-dom'
import { RouteActor, RouteFunctor } from './routes'
import SnipcartEventListener from './containers/SnipcartEventListener'

class App extends React.Component {
  state = {
    init: true,
    accessToken: !!localStorage.getItem('access_token'),
    expiredToken: Moment(
      JSON.parse(localStorage.getItem('expires_at'))
    ).isBefore(),
  }

  componentDidMount() {
    Bluebird.all([
      this.props.fetchBrands(),
      this.props.fetchCategories(),
      this.props.fetchMainMenu('15', 'main'),
    ])
  }

  render() {
    return (
      <BrowserRouter>
        <SnipcartEventListener>
          <ModalErr
            open={!!this.props.err}
            err_msg={this.props.err ? this.props.err.message : null}
            onClose={this.onCloseModal}
          />
          <Header
            main_menu={this.props.main_menu}
            brands={this.props.brands}
            categories={this.props.categories}
          />
          <Switch>
            {RouteFunctor.map((route, key) => (
              <RouteActor key={key} {...route} user={this.props.user} />
            ))}
          </Switch>
          <Footer {...this.props.footer_menu} />
        </SnipcartEventListener>
      </BrowserRouter>
    )
  }
}

const mapStateToProps = state => ({
  main_menu: state.menu.main,
  brands: state.brands,
  categories: state.categories.categories,
  err: state.err,
})

const mapDispatchToProps = dispatch => ({
  fetchMainMenu: (menu_id, type) => {
    dispatch(Menus.fetchMenu(menu_id, type))
  },
  fetchBrands: () => dispatch(Brands.fetchBrands()),
  fetchCategories: () => dispatch(Categories.fetchCategories()),
  clearErr: () => dispatch(Err.clear()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App)
